export default __webpack_public_path__ + "static/media/israel.c1cd69c5.svg";